<section id="photos-table" class="flex flex-col w-full box-border p-6 gap-6 mb-neptune-bar">
    <service-details-kpi-cards></service-details-kpi-cards>

    <ng-container *ngIf="!isToolbarLoading; else skeletonLoaderToolbar">
      <!-- Toolbar : Expand/Collapse buttons, Group By selection and paginator-->
      <!--
        TODO: Extract the toolbar into a standalone component after state management is centralized
        (e.g., via a store). In the current implementation, the toolbar depends on multiple pieces
        of parent-owned state and callbacks (pagination, expand/collapse, advanced filters), and
        extracting it now would introduce significant prop-drilling and increase component coupling.
        -->
      <section
        id="photo-table-toolbar"
        class="flex flex-col items-center justify-between gap-4"
      >
        <!-- Top Section : Expand/Collapse, Advanced Filters, Group By and Paginator controls-->
        <section
          id="photo-table-top-section"
          class="flex items-center justify-between w-full gap-6"
        >
          <section
            id="photo-table-view-controls"
            class="flex justify-between items-center"
          >
            <button
              class="min-w-[150px] flex justify-between items-center"
              aria-label="expand rows"
              (click)="toggleAll(!areAllRowsCollapsed)"
              [ngClass]="
                areAllRowsCollapsed
                  ? 'neptune-button-white'
                  : 'neptune-button-blue'
              "
            >
              {{ areAllRowsCollapsed ? "Expand All" : "Collapse All" }}

              <img
                src="{{
                  areAllRowsCollapsed
                    ? '/assets/shared-icons/neptune-icon-blue-expand.svg'
                    : '/assets/shared-icons/neptune-icon-white-collapse.svg'
                }}"
                alt="{{ areAllRowsCollapsed ? 'Expand All' : 'Collapse All' }}"
              />
            </button>
            <advanced-filters
              [advancedFilterData]="advancedFilterData"
              [excludeKeys]="excludeKeys"
              [pageScope]="'Service Details'"
              [selectedAdvancedFilters]="selectedAdvancedFilters"
              (selectedFilters)="onSelectedFiltersChange($event)"
              [(toggleBody)]="toggleAdvancedFilterSelection"
              [useRefreshedUi]="true"
            >
            </advanced-filters>
          </section>

          <section
            id="photo-table-options"
            class="flex justify-end items-center gap-6"
          >
            <div
              id="group-by-options"
              class="flex justify-center items-center gap-3"
              *ngIf="callType !== SICallTypes.PhotoObservations"
            >
              <span class="text-sm">Group By:</span>

              <single-select-input
                [options]="groupByOptions"
                [value]="displayGroupValue()"
                (valueChange)="onGroupByChange($event)"
                class="border border-solid border-neptune-subtle rounded-md min-w-[80px]"
              >
              </single-select-input>
            </div>

            <div id="paginator-container">
              <paginator
                [currentPage]="currentPage + 1"
                [totalItems]="totalRows"
                [limit]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                (pageChange)="onPageChange($event)"
              >
              </paginator>
            </div>
          </section>
        </section>

        <section class="w-full">
          <advanced-filters-selection
            [advancedFilterData]="advancedFilterData"
            [excludeKeys]="excludeKeys"
            [pageScope]="'Service Details'"
            [selectedAdvancedFilters]="selectedAdvancedFilters"
            (selectedFilters)="onSelectedFiltersChange($event)"
            [(toggleBody)]="toggleAdvancedFilterSelection"
          >
          </advanced-filters-selection>
        </section>

        <!-- Bottom Section : Download Selected Photos toolbar   -->
        <section
          id="photo-table-bottom-section"
          class="flex justify-between items-center gap-6 w-full"
        >
          <photo-selection-bar class="w-full" (cleared)="initializeGroupCounts()"></photo-selection-bar>
        </section>
      </section>

    </ng-container>

    <ng-container *ngIf="!isDataLoading; else skeletonLoaderTable">
      <ng-container *ngIf="!noDataAvailable; else noData">
        <section id="photo-table-rows" class="flex flex-col gap-1">
          <div *ngFor="let group of groupedResult; let groupIndex = index">
            <section
              class="collapsed-item flex justify-between items-center 2xl:text-base p-4 bg-neptune-color-primary-50 border-1 border-solid border-sky-blue rounded-lg text-blue"
            >
              <div class="flex justify-start gap-2">
                <span *ngIf="groupByValue === 'endDate'" class="date">
                  {{ group.sortBy | date: "longDate" }} ({{
                    group.countOfCalls
                  }})
                </span>
                <span *ngIf="groupByValue !== 'endDate'" class="location">
                  {{ group.sortBy }} ({{ group.countOfCalls }})
                </span>
                <button
                  aria-label="expand row"
                  (click)="toggle(groupIndex)"
                  class="bg-transparent flex !p-0"
                >
                  <img
                    src="/assets/shared-icons/neptune-icon-blue-chevron-down.svg"
                    [alt]="
                      hideRuleContent[groupIndex]
                        ? 'Expand Row'
                        : 'Collapse Row'
                    "
                    class="transition-all duration-300"
                    [ngClass]="{
                      'rotate-180': !hideRuleContent[groupIndex],
                    }"
                  />
                </button>
              </div>

              <div
                class="flex justify-end items-center"
                *ngIf="selectedCountsPerGroup[group.sortBy] > 0"
              >
                {{ selectedCountsPerGroup[group.sortBy] }}
                {{
                  selectedCountsPerGroup[group.sortBy] === 1
                    ? "Photo Selected"
                    : "Photos Selected"
                }}
              </div>
            </section>
            <section *ngIf="!hideRuleContent[groupIndex]" class="expanded-item">
              <div
                class="photos-group flex flex-wrap gap-6 bg-neptune-subtle p-6 items-stretch"
              >
                <ng-container *ngIf="group.photos.length > 0; else noPhotos">
                  <ng-container
                    *ngFor="
                      let groupItem of group.photos;
                      let itemIndex = index
                    "
                  >
                    <photo-card
                      [photo]="groupItem"
                      [selected]="isPhotoSelected(groupItem)"
                      [callType]="callType"
                      (photoClick)="openPhotoInPhotoView(groupIndex, itemIndex)"
                      (selectionChange)="
                        togglePhotoSelection(groupItem, group, $event)
                      "
                    />
                  </ng-container>
                </ng-container>
                <ng-template #noPhotos>
                  <div class="no-data">
                    No photos available for the call/calls
                  </div>
                </ng-template>
              </div>
            </section>
          </div>
        </section>
      </ng-container>

      <ng-template #noData>
        <div class="no-data">No Data Available</div>
      </ng-template>
    </ng-container>
  </section>

  <ng-container *ngIf="isPhotoViewOpened">
    <photos-view-window
      [photosList]="photosList"
      [groupedKey]="groupedKey"
      [currentSlideIndex]="currentIndex"
      [showArrows]="photosList.length > 1"
      (closePhotoView)="closePhotoView()"
    ></photos-view-window>
  </ng-container>

<!-- Skeleton Loaders -->
<ng-template #skeletonLoaderToolbar>
  <section id="skeletonLoaderToolbar" class="flex flex-col gap-2 animate-pulse">
    <div class="flex justify-between items-center">
      <div class="h-10 w-[150px] bg-neptune-subtle rounded"></div>
      <div class="h-10 w-[250px] bg-neptune-subtle rounded"></div>
    </div>

    <div class="h-12 w-full bg-neptune-subtle rounded"></div>
  </section>
</ng-template>

<ng-template #skeletonLoaderTable>
  <section
    id="photosTableSkeletonLoader"
    class="flex flex-col gap-4 animate-pulse"
  >
    <div *ngFor="let group of [1, 2, 3]" class="flex flex-col">
      <!-- Group Header -->
      <div class="h-14 w-full rounded-lg bg-neptune-subtle"></div>

      <!-- Photo Container -->
      <div class="flex flex-wrap gap-6 bg-neptune-subtle p-6">
        <div
          *ngFor="let photo of [1, 2, 3, 4]"
          class="photo-card p-4 flex flex-col gap-4 bg-white"
        >
          <!-- Photo -->
          <div class="h-40 w-40 rounded bg-neptune-color-neutral-300"></div>

          <!-- Description -->
          <div class="flex flex-col gap-2">
            <div class="h-4 w-32 rounded bg-neptune-subtle"></div>
            <div class="h-4 w-24 rounded bg-neptune-subtle"></div>
          </div>

          <!-- Caption -->
          <div class="h-3 w-28 rounded bg-neptune-subtle"></div>

          <!-- Link -->
          <div class="h-4 w-20 rounded bg-neptune-subtle"></div>
        </div>
      </div>
    </div>
  </section>
</ng-template>
